export default __webpack_public_path__ + "static/media/MCSW-plant employee.1daa9994.png";